export function getRoundedStarRating(rating = 0) {
	return rating < 0 ? 0 : Math.round(rating * 10) / 10;
}
